<template>
  <div class="projectPage">
        <div class="projectHeader">
            <div class="projectTitle">
                <div class="leftHeader">
                    <div id="projectDetailBtn" class="simpleBtn">
                        <i class="bi bi-three-dots-vertical"></i>
                    </div>
                    <div class="projectName">
                        <i class="bi bi-app"></i>
                        <span>{{projectInfo.Name}}</span>
                    </div>
                </div>
                <div class="rightHeader">
                    <button class="grayBtn" @click="showAlert()">
                        <i class="bi bi-person-add"></i>
                        <span>초대하기</span>
                    </button>
                </div>
            </div>
            <div class="projectMenu">
                <div id="feed" class="projectMenuItem active" @click="navigateProjectMenu('feed')">피드</div>
                <div id="task" class="projectMenuItem" @click="navigateProjectMenu('task')">업무</div>
                <div id="calendar" class="projectMenuItem" @click="navigateProjectMenu('calendar')">캘린더</div>
            </div>
        </div>
        <div class="projectFeedPageContainer">
            <div class="projectFeedPage">
                <!-- 새 글 쓰기 -->
                <div class="create">
                    <div class="selectCategory">
                        <div class="simpleBtn simple55Btn" @click="showAddPostPopup = true">
                            <i class="bi bi-file-earmark-text"></i>
                            <span >글</span>
                        </div>
                        <div class="simpleBtn simple55Btn" @click="showAddTaskPopup = true">
                            <i class="bi bi-card-list"></i>
                            <span>업무</span>
                        </div>
                        <div class="simpleBtn simple55Btn" @click="showAddSchedulePopup = true">
                            <i class="bi bi-calendar-week"></i>
                            <span>일정</span>
                        </div>
                    </div>
                    <div class="inputTxt">
                        <div class="placeholder" @click="showAddPostPopup = true">내용을 입력하세요.</div>
                        <div class="btnBox">
                            <i class="bi bi-paperclip" @click="showAlert()"></i>
                            <i class="bi bi-image" @click="showAlert()"></i>
                            <i class="bi bi-fonts" @click="showAlert()"></i>
                        </div>
                    </div>
                </div>
                <!-- 피드 리스트 -->
                <div class="feedList">
                    <div class="feedListHeader">
                        <div>전체</div>
                        <div class="simpleBtn" @click="showAlert()">
                            <i class="bi bi-funnel"></i>
                            <span>필터</span>
                        </div>
                    </div>

                    <div class="feedListItemBox">
                        <div class="feedListItem" v-for="feed in feedList" :key="feed.feedId" 
                            :class="{textFeed: feed.feedType === 'P', taskFeed: feed.feedType === 'T', scheduleFeed: feed.feedType === 'S'}"
                        >
                            <!-- 글 -->
                            <template v-if="feed.feedType === 'P'">
                                <div class="feedListItemDes">
                                    <div class="feedListItemHeader">
                                        <div class="writterInfo">
                                            <div class="specialUserImg">
                                                <img
                                                    :src="
                                                    feed.createdUserPhoto
                                                        ? `https://mizecloud-partners.co.kr/employee_img/${feed.createdUserPhoto}`
                                                        : defaultProfileImg
                                                    "
                                                    alt="userProfileImg"
                                                />
                                            </div>
                                            <div class="specialUserName">{{ feed.createdUserName }}</div>
                                            <div class="writeTime">{{ formatDate2(feed.createdDtm) }}</div>
                                        </div>
                                        <div class="feedHeaderBtnBox">
                                            <div class="simpleBtn">
                                                <i class="bi bi-pin" @click="showAlert()"></i>
                                            </div>
                                            <div class="simpleBtn">
                                                <i class="bi bi-three-dots-vertical" @click="showAlert()"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="feedListItemBody">
                                        <div class="feedBodyTitle">{{ feed.subject }}</div>
                                        <div class="feedBodyTextDetail">{{ feed.content }}</div>
                                    </div>
                                    <div class="feedListItemFooter">
                                        <div class="feedFooterLeft">
                                            <div class="simpleBtn" @click="likeFeed(feed)">
                                                <i :class="feed.likeActiveYN === 'Y' ? 'bi bi-hand-thumbs-up-fill' : 'bi bi-hand-thumbs-up'"></i>
                                                <span>좋아요</span>
                                            </div>
                                            <div class="simpleBtn" @click="likeBookmark(feed)"> 
                                                <i :class="feed.bookmarkActiveYN === 'Y' ? 'bi bi-bookmark-fill' : 'bi bi-bookmark'"></i>
                                                <span>북마크</span>
                                            </div>
                                            <div class="simpleBtn" @click="showAlert()">
                                                <i class="bi bi-clock-history"></i>
                                                <span>다시 알림</span>
                                            </div>
                                        </div>
                                        <div class="feedFooterRight">
                                            <div class="simpleBtn notBtn">
                                                <span>읽음</span>
                                                <span><b>{{ feed.readCount }}</b></span>
                                            </div>
                                        </div>
                                    </div>
                            
                                    <!-- 글 댓글 -->
                                    <div class="feedListItemComment">
                                        <div class="feedCommentHeader">
                                            <span class="lineBtn active">
                                                <span>댓글</span>
                                                <span><b>{{ feed.commentCount }}</b></span>
                                            </span>
                                        </div>
                                        <div 
                                            class="moreComment txtBtn" 
                                            v-if="feed.comments.length > visibleComments[feed.feedId]"
                                            @click="showMoreComments(feed)"
                                        >
                                            이전 댓글 더보기 ({{ feed.comments.length - (visibleComments[feed.feedId] || 0) }})
                                        </div>
                                        <div class="feedCommentBody">
                                        <!-- 최상위 댓글 -->
                                            <div class="feedCommentItem" v-for="comment in feed.comments.slice(0, visibleComments[feed.feedId] || 0)" :key="comment.id">
                                                <div class="commentLeft">
                                                    <img 
                                                        :src="comment.createdUserPhoto 
                                                            ? `https://mizecloud-partners.co.kr/employee_img/${comment.createdUserPhoto}` 
                                                            : 'https://mizecloud-partners.co.kr/employee_img/default.png'" 
                                                        alt="userProfileImg"
                                                    >
                                                </div>
                                                <div class="commentRight">
                                                <div class="commentHeader">
                                                    <div class="commentHeaderUser">
                                                        <div class="specialUserName">{{ comment.createdUserName }}</div>
                                                        <div class="writeTime">{{ formatDate(comment.createdDtm) }}</div>
                                                    </div>
                                                    <div class="commentHeaderBtnBox">
                                                        <div class="txtBtn" @click="showAlert()">수정</div>
                                                        <div class="txtBtn" @click="showAlert()">삭제</div>
                                                    </div>
                                                </div>
                                                <div class="commentBody">
                                                    {{ comment.commentContent }}
                                                </div>
                                                <div class="commentFooter">
                                                    <div class="simpleBtn" @click="showAlert()">
                                                        <i class="bi bi-arrow-return-right"></i>
                                                        <span>댓글</span>
                                                    </div>
                                                    <div class="simpleBtn" @click="likeFeedComment(comment)">
                                                        <i :class="comment.commentLikeActiveYn === 'Y' ? 'bi bi-hand-thumbs-up-fill' : 'bi bi-hand-thumbs-up'"></i>
                                                        <span>좋아요</span>
                                                    </div>
                                                </div>

                                                <!-- 대댓글 -->
                                                <div class="feedCommentItem recomment" v-for="reply in comment.children" :key="reply.id">
                                                    <div class="commentLeft">
                                                    <img 
                                                        :src="reply.createdUserPhoto 
                                                            ? `https://mizecloud-partners.co.kr/employee_img/${reply.createdUserPhoto}` 
                                                            : 'https://mizecloud-partners.co.kr/employee_img/default.png'" 
                                                        alt="userProfileImg"
                                                    >
                                                    </div>
                                                    <div class="commentRight">
                                                    <div class="commentHeader">
                                                        <div class="commentHeaderUser">
                                                        <div class="specialUserName">{{ reply.createdUserId }}</div>
                                                        <div class="writeTime">{{ reply.createdDtm }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="commentBody">
                                                        {{ reply.commentContent }}
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>                       

                                        <div class="feedCommentFooter leaveComment">
                                            <div class="leaveCommentUser">
                                                <img :src="currentUserPhoto || defaultProfileImg" alt="userProfileImg">                                                    
                                            </div>
                                            <div class="leaveCommentInput formRightIcon">
                                                <textarea 
                                                    type="text" 
                                                    v-model="newComment"
                                                    ref="newComment"
                                                    placeholder="줄바꿈 Shift + Enter / 입력 Enter 입니다."
                                                    @keyup.enter.exact="addComment(feed.feedId, 'P')"
                                                    @keyup.shift.enter="newLine"
                                                ></textarea>
                                                <span class="formIcon">
                                                <i class="bi bi-paperclip" @click="showAlert()"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <!-- 일정 -->
                            <template v-else-if="feed.feedType === 'S'">
                                <div class="feedListItemDes">
                                    <div class="feedListItemHeader">
                                        <div class="writterInfo">
                                            <div class="specialUserImg">
                                                <img
                                                    :src="
                                                    feed.createdUserPhoto
                                                        ? `https://mizecloud-partners.co.kr/employee_img/${feed.createdUserPhoto}`
                                                        : defaultProfileImg
                                                    "
                                                    alt="userProfileImg"
                                                />
                                            </div>
                                            <div class="specialUserName">{{ feed.createdUserName }}</div>
                                            <div class="writeTime">{{ formatDate2(feed.createdDtm) }}</div>
                                        </div>
                                        <div class="feedHeaderBtnBox">
                                            <div class="simpleBtn">
                                                <i class="bi bi-pin" @click="showAlert()"></i>
                                            </div>
                                            <div class="simpleBtn">
                                                <i class="bi bi-three-dots-vertical" @click="showAlert()"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="feedListItemBody scheduleFeedItem">
                                        <div class="feedBodyscheduleTitle">
                                            <div class="scheduleCalendar">
                                                <div class="yearMonth">{{ formatDate3(feed.startDtm, 'yearMonth')}}</div>
                                                <div class="date">{{ formatDate3(feed.startDtm, 'day') }}</div>
                                            </div>
                                            <div class="scheduleInfo">
                                                <div class="scheduleTitle">{{ feed.subject }}</div>
                                                <div class="scheduleDate">{{ formatSchedule(feed) }}</div>
                                            </div>
                                        </div>
                                        <div class="feedBodyDetail">
                                            <div class="detailItem participant">
                                                <div class="detailItemIcon">
                                                    <i class="bi bi-person"></i>
                                                </div>
                                                <div class="detailItemDes">
                                                    <div class="participantListBox">
                                                        <div class="participantList">
                                                            <div 
                                                                v-for="p in feed.participantList" 
                                                                :key="p.participantId"
                                                                :class="[
                                                                    'participantListItem',
                                                                    { 
                                                                        attend: p.attendStatus === 'Y',
                                                                        'non-attend': p.attendStatus === 'N',
                                                                        TBC: p.attendStatus === 'U'
                                                                    }
                                                                ]"
                                                                >
                                                                <img 
                                                                    :src="p.participantUserPhoto 
                                                                    ? `https://mizecloud-partners.co.kr/employee_img/${p.participantUserPhoto}` 
                                                                    : defaultProfileImg" 
                                                                    :alt="p.participantUserName"
                                                                >
                                                            </div>
                                                        </div>
                                                        <span class="underlineBtn" @click="showAlert()">참석자 변경</span>
                                                    </div>
                                                    <div class="participantTotal">
                                                        <div id="attendTotal" class="simpleBtn notBtn">
                                                            <span>참석</span>
                                                            <span><b>{{ feed.summary.attendCount }}</b></span>
                                                        </div>
                                                        <div id="non-attendTotal" class="simpleBtn notBtn">
                                                            <span>불참</span>
                                                            <span><b>{{ feed.summary.nonAttendCount }}</b></span>
                                                        </div>
                                                        <div id="TBCTotal" class="simpleBtn notBtn">
                                                            <span>미정</span>
                                                            <span><b>{{ feed.summary.tbcCount }}</b></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="detailItem locate">
                                                <div class="detailItemIcon">
                                                    <i class="bi bi-geo-alt"></i>
                                                </div>
                                                <div class="detailItemDes">
                                                    <div class="textBox">{{ feed.location ? feed.location : '정보없음' }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="feedBodyAttendBtnBox">
                                            <button class="biglineBtn blue" :class="{ active: getMyAttendStatus(feed) === 'Y' }" @click="updateAttendStatus(feed,'Y')">참석</button>
                                            <button class="biglineBtn red" :class="{ active: getMyAttendStatus(feed) === 'N' }" @click="updateAttendStatus(feed,'N')">불참</button>
                                            <button class="biglineBtn gray" :class="{ active: getMyAttendStatus(feed) === 'U' }" @click="updateAttendStatus(feed,'U')">미정</button>
                                        </div>
                                    </div>
                                    <div class="feedListItemFooter">
                                        <div class="feedFooterLeft">
                                            <div class="simpleBtn" @click="likeFeed(feed)">
                                                <i :class="feed.likeActiveYN === 'Y' ? 'bi bi-hand-thumbs-up-fill' : 'bi bi-hand-thumbs-up'"></i>
                                                <span>좋아요</span>
                                            </div>
                                            <div class="simpleBtn" @click="likeBookmark(feed)">
                                                <i :class="feed.bookmarkActiveYN === 'Y' ? 'bi bi-bookmark-fill' : 'bi bi-bookmark'"></i>
                                                <span>북마크</span>
                                            </div>
                                            <div class="simpleBtn" @click="showAlert()">
                                                <i class="bi bi-clock-history"></i>
                                                <span>다시 알림</span>
                                            </div>
                                        </div>
                                        <div class="feedFooterRight">
                                            <div class="simpleBtn notBtn">
                                                <span>읽음</span>
                                                <span><b>1</b></span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 일정 댓글 -->
                                    <div class="feedListItemComment">
                                        <div class="feedCommentHeader">
                                            <span class="lineBtn active">
                                                <span>전체</span>
                                                <span><b>{{ feed.commentCount }}</b></span>
                                            </span>
                                            <span class="lineBtn">
                                                <span>댓글</span>
                                                <span><b>{{ feed.commentCount }}</b></span>
                                            </span>
                                        </div>
                                        <div class="moreComment txtBtn" v-if="feed.comments.length > visibleComments[feed.feedId]" @click="showMoreComments(feed)">
                                            이전 댓글 더보기 ({{ feed.comments.length - (visibleComments[feed.feedId] || 0) }})</div>
                                        <div class="feedCommentBody">
                                            <div class="feedCommentItem noreply" v-for="comment in feed.comments.slice(0, visibleComments[feed.feedId] || 0)" :key="comment.id">
                                                <div class="commentLeft">
                                                        <img 
                                                        :src="comment.createdUserPhoto 
                                                            ? `https://mizecloud-partners.co.kr/employee_img/${comment.createdUserPhoto}` 
                                                            : 'https://mizecloud-partners.co.kr/employee_img/default.png'" 
                                                        alt="userProfileImg"
                                                    >
                                                </div>
                                                <div class="commentRight">
                                                    <div class="commentHeader">
                                                        <div class="commentHeaderUser">
                                                            <div class="specialUserName">{{ comment.createdUserName }}</div>
                                                            <div class="writeTime">{{ formatDate(comment.createdDtm) }}</div>
                                                        </div>
                                                        <div class="commentHeaderBtnBox">
                                                            <div id="commentEdit" class="txtBtn" @click="showAlert()">수정</div>
                                                            <div id="commentDelet" class="txtBtn" @click="showAlert()">삭제</div>
                                                        </div>
                                                    </div>
                                                    <div class="commentBody">
                                                        {{ comment.commentContent }}
                                                    </div>
                                                    <div class="commentFooter">
                                                        <div id="reply" class="simpleBtn" @click="showAlert()">
                                                            <i class="bi bi-arrow-return-right"></i>
                                                            <span>댓글</span>
                                                        </div>
                                                        <div id="like" class="simpleBtn" @click="likeFeedComment(comment)">
                                                            <i :class="comment.commentLikeActiveYn === 'Y' ? 'bi bi-hand-thumbs-up-fill' : 'bi bi-hand-thumbs-up'"></i>
                                                            <span>좋아요</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="feedCommentFooter leaveComment">
                                            <div class="leaveCommentUser">
                                                <img :src="currentUserPhoto || defaultProfileImg" alt="userProfileImg">                                                    
                                            </div>
                                            <div class="leaveCommentInput formRightIcon">
                                                <textarea 
                                                    type="text" 
                                                    v-model="newComment"
                                                    ref="newComment"
                                                    placeholder="줄바꿈 Shift + Enter / 입력 Enter 입니다."
                                                    @keyup.enter.exact="addComment(feed.feedId, 'S')"
                                                    @keyup.shift.enter="newLine"
                                                ></textarea>
                                                <span class="formIcon">
                                                <i class="bi bi-paperclip" @click="showAlert()"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <!-- 업무 -->
                            <template v-else-if="feed.feedType === 'T'">
                                <div class="feedListItemDes">
                                    <div class="feedListItemHeader">
                                        <div class="writterInfo">
                                            <div class="specialUserImg">
                                                <img
                                                    :src="
                                                    feed.createdUserPhoto
                                                        ? `https://mizecloud-partners.co.kr/employee_img/${feed.createdUserPhoto}`
                                                        : defaultProfileImg
                                                    "
                                                    alt="userProfileImg"
                                                />
                                            </div>
                                            <div class="specialUserName">{{ feed.createdUserName }}</div>
                                            <div class="writeTime">{{ formatDate2(feed.createdDtm) }}</div>
                                        </div>
                                        <div class="feedHeaderBtnBox">
                                            <div class="simpleBtn">
                                                <i class="bi bi-pin" @click="showAlert()"></i>
                                            </div>
                                            <div class="simpleBtn">
                                                <i class="bi bi-three-dots-vertical" @click="showAlert()"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="feedListItemBody taskFeedItem">
                                        <div class="feedBodyTaskTitle">
                                            <div class="feedBodyTitle">{{ feed.subject }}</div>
                                            <span class="taskNumber biglineBtn">업무번호 {{ feed.feedId }}</span>    
                                        </div>
                                        <div class="feedBodyDetail">
                                            <div class="detailItem status">
                                                <div class="detailItemIcon">
                                                    <i class="bi bi-bar-chart-steps"></i>
                                                </div>
                                                <div class="detailItemDes">
                                                    <div class="statusBtnBox">
                                                        <div class="statusBtn request" :class="{ active: feed.status === 'R' }">요청</div>
                                                        <div class="statusBtn inProgress" :class="{ active: feed.status === 'P' }">진행</div>
                                                        <div class="statusBtn feedback" :class="{ active: feed.status === 'F' }">피드백</div>
                                                        <div class="statusBtn completed" :class="{ active: feed.status === 'C' }">완료</div>
                                                        <div class="statusBtn onHold" :class="{ active: feed.status === 'H' }">보류</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="detailItem manager">
                                                <div class="detailItemIcon">
                                                    <i class="bi bi-person"></i>
                                                </div>
                                                <div class="flexAlignCenter">
                                                    <div class="detailItemDes">
                                                        <div class="selectedUser">
                                                            <div class="userInfo">
                                                                <div class="specialUserImg">
                                                                    <img
                                                                        :src="
                                                                        feed.managerUserPhoto
                                                                            ? `https://mizecloud-partners.co.kr/employee_img/${feed.managerUserPhoto}`
                                                                            : defaultProfileImg
                                                                        "
                                                                        alt="userProfileImg"
                                                                    />
                                                                </div>
                                                                <div class="specialUserName">{{ feed.managerUserName }}</div>
                                                            </div>
                                                            <span class="xBtn" @click="showAlert()"><i class="bi bi-x-lg"></i></span>
                                                        </div>
                                                    </div>
                                                    <span class="underlineBtn" @click="showAlert()">담당자 변경</span>
                                                </div>
                                            </div>
                                            <div class="detailItem startDate">
                                                <div class="detailItemIcon">
                                                    <i class="bi bi-calendar"></i>
                                                </div>
                                                <div class="flexAlignCenter">
                                                    <div class="detailItemDes">
                                                        <div class="textBox">
                                                            <span>{{ feed.startDate }} ({{getWeekofDay(feed.startDate)}}) 부터</span>
                                                            <span class="xBtn" @click="showAlert()"><i class="bi bi-x-lg"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="detailItem endDate">
                                                <div class="detailItemIcon">
                                                    <i class="bi bi-calendar"></i>
                                                </div>
                                                <div class="flexAlignCenter">
                                                    <div class="detailItemDes">
                                                        <div class="textBox">
                                                            <span>{{ feed.endDate }} ({{getWeekofDay(feed.endDate)}}) 까지</span>
                                                            <span class="xBtn" @click="showAlert()"><i class="bi bi-x-lg"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="detailItem priority" v-if="feed.priority.trim() !== ''">
                                                <div class="detailItemIcon">
                                                    <i class="bi bi-flag"></i>
                                                </div>
                                                <div class="flexAlignCenter">
                                                    <div class="detailItemDes">
                                                        <div class="textBox">
                                                            <span class="simpleBtn notBtn priority1">
                                                                <i class="bi bi-fire"></i>
                                                                <span>
                                                                    {{ feed.priority === 'L' ? '낮음' : feed.priority === 'M' ? '보통' : feed.priority === 'H' ? '높음' : '긴급' }}
                                                                </span>
                                                            </span>
                                                            <span class="xBtn" @click="showAlert()"><i class="bi bi-x-lg"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="detailItem progress" v-if="feed.progressNum !== '0'">
                                                <div class="detailItemIcon">
                                                    <i class="bi bi-segmented-nav"></i>
                                                </div>
                                                <div class="flexAlignCenter">
                                                    <div class="detailItemDes">
                                                        <div class="progressBox">
                                                            <progress max="100" value="70"></progress>
                                                            <span>{{ feed.progressNum }}%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="feedBodyTextDetail">{{ feed.content }}</div>
                                        <div class="feedBodySubTaskBox" v-if="feed.subTaskList && feed.subTaskList.length">
                                            <div class="subTaskTitleBox">
                                                <span class="subTaskIcon"><i class="bi bi-list-task"></i></span>
                                                <span class="subTaskTitle">하위업무</span>
                                            </div>
                                            <div class="subTaskListBox">
                                                <div class="subTaskListItem" v-for="sub in feed.subTaskList" :key="sub.subTaskId">
                                                    <div class="subTaskInfo">
                                                        <span :class="['statusBtnSmall', getStatusClass(sub.subTaskStatus)]">
                                                            {{ getStatusLabel(sub.subTaskStatus) }}
                                                        </span>
                                                        <span class="subTaskTxt">{{ sub.subTaskSubject }}</span>
                                                        <span class="subTaskComment">
                                                        <i class="bi bi-chat-square-dots"></i>
                                                        <b>1</b>
                                                        </span>
                                                    </div>
                                                    <div class="writterInfo">
                                                        <img
                                                            :src="
                                                            sub.subTaskManagerUserPhoto
                                                                ? `https://mizecloud-partners.co.kr/employee_img/${sub.subTaskManagerUserPhoto}`
                                                                : defaultProfileImg
                                                            "
                                                            alt="userProfileImg"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="subTaskListBox">
                                                <button class="biglineBtn">
                                                    <i class="bi bi-plus-lg"></i>
                                                    <span>하위업무 추가</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="feedListItemFooter">
                                        <div class="simpleBtn" @click="likeFeed(feed)">
                                            <i :class="feed.likeActiveYN === 'Y' ? 'bi bi-hand-thumbs-up-fill' : 'bi bi-hand-thumbs-up'"></i>
                                            <span>좋아요</span>
                                        </div>
                                        <div class="simpleBtn" @click="likeBookmark(feed)">
                                            <i :class="feed.bookmarkActiveYN === 'Y' ? 'bi bi-bookmark-fill' : 'bi bi-bookmark'"></i>
                                            <span>북마크</span>
                                        </div>
                                        <div class="simpleBtn" @click="showAlert()">
                                            <i class="bi bi-clock-history"></i>
                                            <span>다시 알림</span>
                                        </div>
                                        <div class="feedFooterRight">
                                            <div class="simpleBtn notBtn">
                                                <span>읽음</span>
                                                <span><b>1</b></span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 업무 댓글 -->
                                    <div class="feedListItemComment">
                                        <div class="feedCommentHeader">
                                            <span class="lineBtn active">
                                                <span>전체</span>
                                                <span><b>{{ feed.commentCount }}</b></span>
                                            </span>
                                            <span class="lineBtn">
                                                <span>댓글</span>
                                                <span><b>{{ feed.commentCount }}</b></span>
                                            </span>
                                        </div>
                                        <div class="moreComment txtBtn" v-if="feed.comments.length > visibleComments[feed.feedId]" @click="showMoreComments(feed)">
                                            이전 댓글 더보기 ({{ feed.comments.length - (visibleComments[feed.feedId] || 0) }})
                                        </div>
                                        <div class="feedCommentBody">
                                            <div class="feedCommentItem noreply" v-for="comment in feed.comments.slice(0, visibleComments[feed.feedId] || 0)" :key="comment.id">
                                                <div class="commentLeft">
                                                        <img 
                                                        :src="comment.createdUserPhoto 
                                                            ? `https://mizecloud-partners.co.kr/employee_img/${comment.createdUserPhoto}` 
                                                            : 'https://mizecloud-partners.co.kr/employee_img/default.png'" 
                                                        alt="userProfileImg"
                                                    >
                                                </div>
                                                <div class="commentRight">
                                                    <div class="commentHeader">
                                                        <div class="commentHeaderUser">
                                                            <div class="specialUserName">{{ comment.createdUserName }}</div>
                                                            <div class="writeTime">{{ formatDate(comment.createdDtm) }}</div>
                                                        </div>
                                                        <div class="commentHeaderBtnBox">
                                                            <div id="commentEdit" class="txtBtn" @click="showAlert()">수정</div>
                                                            <div id="commentDelet" class="txtBtn" @click="showAlert()">삭제</div>
                                                        </div>
                                                    </div>
                                                    <div class="commentBody">
                                                        {{ comment.commentContent }}
                                                    </div>
                                                    <div class="commentFooter">
                                                        <div id="reply" class="simpleBtn" @click="showAlert()">
                                                            <i class="bi bi-arrow-return-right"></i>
                                                            <span>댓글</span>
                                                        </div>
                                                        <div id="like" class="simpleBtn" @click="likeFeedComment(comment)">
                                                            <i :class="comment.commentLikeActiveYn === 'Y' ? 'bi bi-hand-thumbs-up-fill' : 'bi bi-hand-thumbs-up'"></i>
                                                            <span>좋아요</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="feedCommentFooter leaveComment">
                                            <div class="leaveCommentUser">
                                                <img :src="currentUserPhoto || defaultProfileImg" alt="userProfileImg">                                                    
                                            </div>
                                            <div class="leaveCommentInput formRightIcon">
                                                <textarea 
                                                    type="text" 
                                                    v-model="newComment"
                                                    ref="newComment"
                                                    placeholder="줄바꿈 Shift + Enter / 입력 Enter 입니다."
                                                    @keyup.enter.exact="addComment(feed.feedId, 'T')"
                                                    @keyup.shift.enter="newLine"
                                                ></textarea>
                                                <span class="formIcon">
                                                <i class="bi bi-paperclip" @click="showAlert()"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 글 작성 모달 -->
    <div class="modalBg createTextFeed " v-show="showAddPostPopup">
        <div class="modalBox createTextFeedBox">
            <div class="modalHeader">
                <div class="modalTitleBox">
                    <div class="modalTitle">
                        <h5>게시물 작성</h5>
                        <span class="gap"></span>
                        <span class="modalchangeProjectBox">
                            <i class="bi bi-chevron-down"></i>
                            <div class="selectedProject">
                                <i class="bi bi-app"></i><span>{{this.projectName}}</span>
                            </div>
                        </span>
                    </div>
                    <div class="modalHeaderBtnBox">
                        <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                        <span class="closeBtn" @click="showAddPostPopup = false;initPostPopupVaule();"><i class="bi bi-x-lg"></i></span>
                    </div>
                </div>
                <div class="modalMenu">
                    <div class="selectCategory">
                        <div class="simpleBtn simple55Btn active" @click="initAllPopup('post')">
                            <i class="bi bi-file-earmark-text"></i>
                            <span>글</span>
                        </div>
                        <div class="simpleBtn simple55Btn" @click="initAllPopup('task')">
                            <i class="bi bi-card-list"></i>
                            <span>업무</span>
                        </div>
                        <div class="simpleBtn simple55Btn" @click="initAllPopup('schedule')">
                            <i class="bi bi-calendar-week"></i>
                            <span>일정</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modalBody">
                <div class="modalFeedTitleInputBox">
                    <input type="text" class="modalFeedTitleInput" v-model="postSubject" ref="postSubject" placeholder="제목을 작성하세요." >
                </div>
                <div class="modalFeedDesInputBox">
                    <textarea name="" id="" class="modalFeedDesInput" v-model="postContent" ref="postContent" placeholder="내용을 작성하세요."></textarea>
                </div>
            </div>
            <div class="modalFooter">
                <div class="modalFooterBtnBox">
                    <div class="btnBox">
                        <i class="bi bi-fonts" @click="showAlert()"></i>
                        <i class="bi bi-paperclip" @click="showAlert()"></i>
                        <i class="bi bi-geo-alt" @click="showAlert()"></i>
                    </div>
                </div>
                <div class="modalFooterBtnBox">
                    <div class="dropdown">
                        <div class="dropdown-button" @click="toggleDropdown">{{ selectedOption }}</div>
                        <div class="dropdown-menu" v-show="isDropdownOpen">
                            <div class="dropdown-item" @click="selectItem('전체공개')">전체공개</div>
                            <div class="dropdown-item" @click="selectItem('프로젝트 관리자만')">프로젝트 관리자만</div>
                        </div>
                    </div>
                    <div class="preStorage" @click="showAlert()">
                        <span>임시저장</span>
                        <span class="gap"></span>
                        <span><b>0</b></span>
                    </div>
                    <button class="blueBtn" @click="addPost">등록</button>
                </div>
            </div>
        </div>
    </div>
    <!-- 업무 작성 모달 -->
    <div class="modalBg createTaskFeed " v-show="showAddTaskPopup">
        <div class="modalBox createTaskFeedBox">
            <div class="modalHeader">
                <div class="modalTitleBox">
                    <div class="modalTitle">
                        <h5>게시물 작성</h5>
                        <span class="gap"></span>
                        <span class="modalchangeProjectBox">
                            <i class="bi bi-chevron-down"></i>
                            <div class="selectedProject">
                                <i class="bi bi-app"></i><span>{{this.projectName}}</span>
                            </div>
                        </span>
                    </div>
                    <div class="modalHeaderBtnBox">
                        <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                        <span class="closeBtn" @click="showAddTaskPopup = false;initTaskPopupVaule();"><i class="bi bi-x-lg"></i></span>
                    </div>
                </div>
                <div class="modalMenu">
                    <div class="selectCategory">
                        <div class="simpleBtn simple55Btn" @click="initAllPopup('post')">
                            <i class="bi bi-file-earmark-text"></i>
                            <span>글</span>
                        </div>
                        <div class="simpleBtn simple55Btn active" @click="initAllPopup('task')">
                            <i class="bi bi-card-list"></i>
                            <span>업무</span>
                        </div>
                        <div class="simpleBtn simple55Btn" @click="initAllPopup('schedule')">
                            <i class="bi bi-calendar-week"></i>
                            <span>일정</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modalBody">
                <div class="modalFeedTitleInputBox">
                    <input type="text" class="modalFeedTitleInput" v-model="taskSubject" ref="taskSubject" placeholder="제목을 작성하세요.">
                </div>
                <div class="modalFeedDetailItemBox">

                    <div class="detailItem status">
                        <div class="detailItemIcon">
                            <i class="bi bi-bar-chart-steps"></i>
                        </div>
                        <div class="detailItemDes">
                            <div class="statusBtnBox">
                                <div class="statusBtn request" :class="{ active: selectedTaskStatus === 'R' }" @click="selectedTaskStatus = 'R'">요청</div>
                                <div class="statusBtn inProgress" :class="{ active: selectedTaskStatus === 'P' }" @click="selectedTaskStatus = 'P'">진행</div>
                                <div class="statusBtn feedback" :class="{ active: selectedTaskStatus === 'F' }" @click="selectedTaskStatus = 'F'">피드백</div>
                                <div class="statusBtn completed" :class="{ active: selectedTaskStatus === 'C' }" @click="selectedTaskStatus = 'C'">완료</div>
                                <div class="statusBtn onHold" :class="{ active: selectedTaskStatus === 'H' }" @click="selectedTaskStatus = 'H'">보류</div>
                            </div>
                        </div>
                    </div>

                    <div class="detailItem manager">
                        <div class="detailItemIcon">
                            <i class="bi bi-person"></i>
                        </div>
                        <div class="flexAlignCenter">
                            <!-- ▼ 담당자 추가 시 생성 ▼ -->
                            <div class="detailItemDes" v-if="selectedTaskManager">
                                <div class="selectedUser">
                                    <div class="userInfo">
                                        <div class="specialUserImg">
                                            <img :src="selectedTaskManager.managerUserPhoto ? 
                                            `https://mizecloud-partners.co.kr/employee_img/${selectedTaskManager.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'" alt="userProfileImg"/>
                                        </div>
                                        <div class="specialUserName">{{ selectedTaskManager.managerUserName }}</div>
                                    </div>
                                    <span class="xBtn" @click="selectedTaskManager = ''"><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            <span class="underlineBtn" @click="searchManagerName = ''; isManagerPopupOpen = !isManagerPopupOpen" v-if="!selectedTaskManager">담당자 추가</span>
                            <!-- ▼ 담당자 추가 시 class="active" 추가 -> 나타남 -->
                            <div class="peopleSelectBox" :class="{ active: isManagerPopupOpen }">
                                <div class="peopleSearch formRightIcon">
                                    <input type="text" :value="searchManagerName" @input="handleManagerInput" id="peopleSearch" placeholder="검색어를 입력해주세요"/>
                                    <span class="formIcon">
                                        <i class="bi bi-search"></i>
                                    </span>
                                </div>
                                <div class="peopleListBox">
                                <div class="peopleList" ref="peopleList">
                                    <div class="peopleItem" v-for="person in searchManagerUserList" :key="person.managerUserId" @click="selectTaskManager(person)">
                                        <div class="specialUserInfo">
                                        <div class="specialUserImg">
                                            <img
                                                :src="
                                                person.managerUserPhoto
                                                    ? `https://mizecloud-partners.co.kr/employee_img/${person.managerUserPhoto}`
                                                    : 'https://mizecloud-partners.co.kr/employee_img/default.png'
                                                "
                                                alt="profileImg"
                                            />
                                        </div>
                                        <div class="specialUserDes">
                                            <div class="specialUserName">
                                            {{ person.managerUserName }} <span>{{ person.managerUserPosition }}</span>
                                            </div>
                                            <div class="specialUserTeam">{{ person.managerUserDept }}</div>
                                        </div>
                                        </div>
                                    </div>
                                    <div v-if="searchManagerUserList.length === 0 && searchManagerName.trim() !== ''" class="noResult">
                                        검색 결과가 없습니다.
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                    <div class="detailItem startDate">
                        <div class="detailItemIcon">
                            <i class="bi bi-calendar"></i>
                        </div>
                        <div class="flexAlignCenter">
                            <!-- ▼ 시작일 추가 시 생성 ▼ -->
                            <div class="detailItemDes" v-if="selectedTaskStartDate">
                                <div class="textBox">
                                    <span>{{ formattedTaskStartDate }}</span>
                                    <span class="xBtn" @click="selectedTaskStartDate = null"><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            <span class="underlineBtn" @click="isTaskStartDatePickerOpen = true" v-if="!selectedTaskStartDate">시작일 추가</span>
                            <DatePicker
                                :value="selectedTaskStartDate"
                                @change="handleTaskStartDateChange"
                                v-model:open="isTaskStartDatePickerOpen"
                            >
                                <template #input></template>                        
                                <template #icon-calendar></template>
                            </DatePicker>
                        </div>
                    </div>
                    
                    <div class="detailItem endDate">
                        <div class="detailItemIcon">
                            <i class="bi bi-calendar"></i>
                        </div>
                        <div class="flexAlignCenter">
                            <!-- ▼ 마감일 추가 시 생성 ▼ -->
                            <div class="detailItemDes" v-if="selectedTaskEndDate">
                                <div class="textBox">
                                    <span>{{ formattedTaskEndDate }}</span>
                                    <span class="xBtn" @click="selectedTaskEndDate = null"><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            <span class="underlineBtn" @click="isTaskEndDatePickerOpen = true" v-if="!selectedTaskEndDate">마감일 추가</span>
                            <DatePicker
                                :value="selectedTaskEndDate"
                                @change="handleTaskEndDateChange"
                                v-model:open="isTaskEndDatePickerOpen"
                            >
                                <template #input></template>                        
                                <template #icon-calendar></template>
                            </DatePicker>
                        </div>
                    </div>

                    <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                    <div class="detailItem priority" v-if="isPriorityProgressOpen">
                        <div class="detailItemIcon">
                            <i class="bi bi-flag"></i>
                        </div>
                        <div class="flexAlignCenter">
                            <!-- ▼ 우선순위 추가 시 생성 ▼ -->
                            <div class="detailItemDes" v-if="selectedPriority">
                                <div class="textBox">
                                    <span class="simpleBtn notBtn" :class="selectedPriority.class">
                                        <i class="bi" :class="selectedPriority.icon"></i>
                                        <span>{{ selectedPriority.text }}</span>
                                    </span>
                                    <span class="xBtn" @click="selectedPriority = null; isPriorityPopupOpen = false;">
                                        <i class="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>
                            <span class="underlineBtn" @click="isPriorityPopupOpen = true" v-if="!selectedPriority">우선순위 추가</span>
                            <!-- ▼ 우선순위 추가 시 class="active" 추가 -> 나타남 -->
                            <div class="prioritySelectBox" :class="{ active: isPriorityPopupOpen }">
                                <div 
                                    v-for="priority in priorities" 
                                    :key="priority.id"
                                    class="simpleBtn"
                                    :class="priority.class"
                                    @click="selectPriority(priority)"
                                >
                                    <i class="bi" :class="priority.icon"></i>
                                    <span>{{ priority.text }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                    <div class="detailItem progress" v-if="isPriorityProgressOpen">
                        <div class="detailItemIcon">
                            <i class="bi bi-segmented-nav"></i>
                        </div>
                        <div class="flexAlignCenter">
                            <div class="detailItemDes">
                                <div class="progressBox">
                                    <input type="range" min="0" max="100" :value="taskProgress" @input="updateTaskProgress" />
                                    <span>{{ taskProgress }}%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="subTaskListBox">
                        <button class="biglineBtn" @click="isPriorityProgressOpen = true;" v-if="!isPriorityProgressOpen">
                            <i class="bi bi-plus-lg"></i>
                            <span>항목추가입력</span>
                        </button>
                    </div>
                </div>
                <div class="modalFeedDesInputBox">
                    <textarea name="" id="" class="modalFeedDesInput" v-model="taskContent" ref="taskContent" placeholder="내용을 작성하세요."></textarea>
                </div>
                <div class="">
                    <div class="feedBodySubTaskBox">
                        <div class="subTaskTitleBox">
                            <span class="subTaskIcon"><i class="bi bi-list-task"></i></span>
                            <span class="subTaskTitle">하위업무</span>
                        </div>
                        <div class="subTaskListBox">
                            <div class="subTaskListItem" v-for="subTask in subTaskList" :key="subTask.id">
                                <div class="subTaskInfo">
                                    <span class="statusBtnSmall request">{{ statusMap[subTask.status] }}</span>
                                    <span class="subTaskTxt">
                                        <input type="text" v-model="subTask.name" placeholder="업무명 입력" @keyup.enter="handleEnter(subTask)" :ref="'subtask_' + subTask.id">
                                    </span>
                                </div>
                                <div class="subTaskInfo" style="position: relative;">
                                    <span class="circleBtn" @click="toggleDatePicker(subTask)">
                                        <i class="bi bi-calendar" :style="subTask.subTaskEndDate ? 'color: #007bff;' : ''"></i>
                                    </span>
                                    <span class="circleBtn" @click="togglePriorityPopup(subTask)">
                                        <i class="bi" :class="subTask.selectedSubTaskPriority ? subTask.selectedSubTaskPriority.icon : 'bi-caret-down-fill'"
                                        :style="{ color: subTask.selectedSubTaskPriority ? subTask.selectedSubTaskPriority.color : '' + ' !important' }"></i>
                                    </span>
                                    <span class="circleBtn" @click="toggleManagerPopup(subTask)">
                                        <img
                                            v-if="subTask.selectedSubTaskManager"
                                            :src="subTask.selectedSubTaskManager.managerUserPhoto ? `https://mizecloud-partners.co.kr/employee_img/${subTask.selectedSubTaskManager.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'"
                                            alt="profileImg"
                                            class="profile-thumbnail" style="border-radius: 50%;"
                                        />
                                        <i v-else class="bi bi-person"></i>
                                    </span>
                                    <span v-if="subTask.isDatePickerOpen">
                                        <DatePicker
                                            :value="subTask.subTaskEndDate"
                                            @change="subTask.subTaskEndDate = $event; subTask.isDatePickerOpen = false;"
                                            :teleport="true"
                                            :auto-apply="true"
                                            inline
                                        />
                                    </span>
                                    
                                    <div class="prioritySelectBox" v-if="subTask.isSubTaskPriorityPopupOpen" 
                                        style="position: absolute !important;top:100% !important;right:0 !important;z-index:9999 !important; display: block !important;">
                                        <div 
                                            v-for="priority in subTaskPriorities" 
                                            :key="priority.id"
                                            class="simpleBtn"
                                            :class="priority.class"
                                            @click="selectSubTaskPriority(subTask, priority)"
                                        >
                                            <i class="bi" :class="priority.icon"></i>
                                            <span>{{ priority.text }}</span>
                                        </div>
                                    </div>

                                    <div class="peopleSelectBox" v-if="subTask.isSubTaskManagerPopupOpen" 
                                        style="position: absolute !important;top:100% !important;right:0 !important;z-index:9999 !important; display: block !important;">
                                        <div class="peopleSearch formRightIcon">
                                            <input type="text" :value="searchManagerName" @input="handleManagerInput" id="peopleSearch" placeholder="검색어를 입력해주세요"/>
                                            <span class="formIcon">
                                                <i class="bi bi-search"></i>
                                            </span>
                                        </div>
                                        <div class="peopleListBox">
                                            <div class="peopleList" ref="peopleList">
                                                <div class="peopleItem" v-for="person in searchManagerUserList" :key="person.managerUserId" @click="selectSubTaskManager(subTask, person)">
                                                    <div class="specialUserInfo">
                                                        <div class="specialUserImg">
                                                            <img
                                                                :src="person.managerUserPhoto ? `https://mizecloud-partners.co.kr/employee_img/${person.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'"
                                                                alt="profileImg"
                                                            />
                                                        </div>
                                                        <div class="specialUserDes">
                                                            <div class="specialUserName">
                                                                {{ person.managerUserName }} <span>{{ person.managerUserPosition }}</span>
                                                            </div>
                                                            <div class="specialUserTeam">{{ person.managerUserDept }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="searchManagerUserList.length === 0 && searchManagerName.trim() !== ''" class="noResult">
                                                    검색 결과가 없습니다.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>                        
                        <div class="subTaskListBox">
                            <button class="biglineBtn" @click="addSubTask">
                                <i class="bi bi-plus-lg"></i>
                                <span>하위업무 추가</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modalFooter">
                <div class="modalFooterBtnBox">
                    <div class="btnBox">
                        <i class="bi bi-fonts" @click="showAlert()"></i>
                        <i class="bi bi-paperclip" @click="showAlert()"></i>
                        <i class="bi bi-geo-alt" @click="showAlert()"></i>
                    </div>
                </div>
                <div class="modalFooterBtnBox">
                    <div class="dropdown">
                        <div class="dropdown-button" @click="toggleDropdown">{{ selectedOption }}</div>
                        <div class="dropdown-menu" v-show="isDropdownOpen">
                            <div class="dropdown-item" @click="selectItem('전체공개')">전체공개</div>
                            <div class="dropdown-item" @click="selectItem('프로젝트 관리자만')">프로젝트 관리자만</div>
                        </div>
                    </div>
                    <div class="preStorage" @click="showAlert()">
                        <span>임시저장</span>
                        <span class="gap"></span>
                        <span><b>0</b></span>
                    </div>
                    <button class="blueBtn" @click="addTask">등록</button>
                </div>
            </div>
        </div>
    </div>
    <!-- 일정 작성 모달 -->
    <div class="modalBg createScheduleFeed " v-show="showAddSchedulePopup">
        <div class="modalBox createTextFeedBox">
            <div class="modalHeader">
                <div class="modalTitleBox">
                    <div class="modalTitle">
                        <h5>게시물 작성</h5>
                        <span class="gap"></span>
                        <span class="modalchangeProjectBox">
                            <i class="bi bi-chevron-down"></i>
                            <div class="selectedProject">
                                <i class="bi bi-app"></i><span>{{this.projectName}}</span>
                            </div>
                        </span>
                    </div>
                    <div class="modalHeaderBtnBox">
                        <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                        <span class="closeBtn" @click="showAddSchedulePopup = false;initSchedulePopupVaule();"><i class="bi bi-x-lg"></i></span>
                    </div>
                </div>
                <div class="modalMenu">
                    <div class="selectCategory">
                        <div class="simpleBtn simple55Btn" @click="initAllPopup('post')">
                            <i class="bi bi-file-earmark-text"></i>
                            <span>글</span>
                        </div>
                        <div class="simpleBtn simple55Btn" @click="initAllPopup('task')">
                            <i class="bi bi-card-list"></i>
                            <span>업무</span>
                        </div>
                        <div class="simpleBtn simple55Btn active" @click="initAllPopup('schedule')">
                            <i class="bi bi-calendar-week"></i>
                            <span>일정</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modalBody">
                <div class="modalFeedTitleInputBox">
                    <input type="text" class="modalFeedTitleInput" v-model="scheduleSubject" ref="scheduleSubject" placeholder="제목을 작성하세요.">
                </div>
                <div class="modalFeedDetailItemBox">

                    <div class="detailItem scheduleDateTime">
                        <div class="detailItemIcon">
                            <i class="bi bi-calendar"></i>
                        </div>
                        <div class="flexAlignCenter">
                            <div class="detailItemDes">
                                <div class="dateBox">
                                    <input type="datetime-local" name="" id="startDateTime" v-model="scheduleStartDateTime" ref="scheduleStartDateTime" @input="handleScheduleStartDateChange">
                                    <span><i class="bi bi-dash-lg"></i></span>
                                    <input type="datetime-local" name="" id="endDateTime" v-model="scheduleEndDateTime" ref="scheduleEndDateTime" @input="handleScheduleEndDateChange">
                                </div>
                            </div> 
                            <label class="checkboxBox" @click="checkAllDayClick">
                                <input type="checkbox" name="" id="" v-model="isAllDay" :disabled="!canCheckAllDay" true-value="Y" false-value="N">
                                <span>종일</span>
                            </label>
                        </div>
                    </div>

                    <div class="detailItem manager">
                        <div class="detailItemIcon">
                            <i class="bi bi-person"></i>
                        </div>
                        <div class="flexAlignCenter">
                            <div class="detailItemDes" v-if="selectedParticipantUserList.length">
                                <div class="selectedUser" v-for="(participantUser, index) in selectedParticipantUserList" :key="participantUser.managerUserId || index">
                                    <div class="userInfo">
                                        <div class="specialUserImg">
                                            <img :src="participantUser.managerUserPhoto ? 
                                            `https://mizecloud-partners.co.kr/employee_img/${participantUser.managerUserPhoto}` : 'https://mizecloud-partners.co.kr/employee_img/default.png'" alt="userProfileImg"/>
                                        </div>
                                        <div class="specialUserName">{{ participantUser.managerUserName }}</div>
                                    </div>
                                    <span class="xBtn" @click="removeParticipant(index)"><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            <span class="underlineBtn" @click="searchParticipantName = ''; isParticipantPopupOpen = !isParticipantPopupOpen">참석자 추가</span>
                            <!-- <div class="detailItemDes">
                                <div class="selectedUser">
                                    <div class="userInfo">
                                        <div class="specialUserImg">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                        </div>
                                        <div class="specialUserName">홍길동</div>
                                    </div>
                                    <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            <span class="underlineBtn">참석자 추가</span> -->
                            <div class="peopleSelectBox" :class="{ active: isParticipantPopupOpen }">
                                <div class="peopleSearch formRightIcon">
                                    <input type="text" :value="searchParticipantName" @input="handleParticipantInput" id="peopleSearch" placeholder="검색어를 입력해주세요"/>
                                    <span class="formIcon">
                                        <i class="bi bi-search"></i>
                                    </span>
                                </div>
                                <div class="peopleListBox">
                                <div class="peopleList" ref="peopleList">
                                    <div class="peopleItem" v-for="person in searchParticipantUserList" :key="person.managerUserId" @click="selectScheduleParticipant(person)">
                                        <div class="specialUserInfo">
                                        <div class="specialUserImg">
                                            <img
                                                :src="
                                                person.managerUserPhoto
                                                    ? `https://mizecloud-partners.co.kr/employee_img/${person.managerUserPhoto}`
                                                    : 'https://mizecloud-partners.co.kr/employee_img/default.png'
                                                "
                                                alt="profileImg"
                                            />
                                        </div>
                                        <div class="specialUserDes">
                                            <div class="specialUserName">
                                            {{ person.managerUserName }} <span>{{ person.managerUserPosition }}</span>
                                            </div>
                                            <div class="specialUserTeam">{{ person.managerUserDept }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="searchParticipantUserList.length === 0 && searchParticipantName.trim() !== ''" class="noResult">
                                    검색 결과가 없습니다.
                                </div>
                                </div>
                                </div>
                            </div>
                            <!-- ▼ 담당자 추가 시 class="active" 추가 -> 나타남 -->
                            <!-- <div class="peopleSelectBox">
                                <div class="peopleSearch formRightIcon">
                                <input type="search" name="peopleSearch" id="peopleSearch" placeholder="검색어를 입력해주세요">
                                <span class="formIcon">
                                    <i class="bi bi-search"></i>
                                </span>
                                </div>
                                <div class="peopleListBox">
                                <div class="peopleList">
                                    <div class="peopleItem">
                                    <div class="specialUserInfo">
                                        <div class="specialUserImg">
                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                        </div>
                                        <div class="specialUserDes">
                                        <div class="specialUserName">홍길동 <span>사원</span></div>
                                        <div class="specialUserTeam">연구개발본부 개발팀</div>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="peopleItem">
                                    <div class="specialUserInfo">
                                        <div class="specialUserImg">
                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                        </div>
                                        <div class="specialUserDes">
                                        <div class="specialUserName">홍길동 <span>사원</span></div>
                                        <div class="specialUserTeam">연구개발본부 개발팀</div>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="peopleItem">
                                    <div class="specialUserInfo">
                                        <div class="specialUserImg">
                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                        </div>
                                        <div class="specialUserDes">
                                        <div class="specialUserName">홍길동 <span>사원</span></div>
                                        <div class="specialUserTeam">연구개발본부 개발팀</div>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="peopleItem">
                                    <div class="specialUserInfo">
                                        <div class="specialUserImg">
                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                        </div>
                                        <div class="specialUserDes">
                                        <div class="specialUserName">홍길동 <span>사원</span></div>
                                        <div class="specialUserTeam">연구개발본부 개발팀</div>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="peopleItem">
                                    <div class="specialUserInfo">
                                        <div class="specialUserImg">
                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                        </div>
                                        <div class="specialUserDes">
                                        <div class="specialUserName">홍길동 <span>사원</span></div>
                                        <div class="specialUserTeam">연구개발본부 개발팀</div>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="peopleItem">
                                    <div class="specialUserInfo">
                                        <div class="specialUserImg">
                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                        </div>
                                        <div class="specialUserDes">
                                        <div class="specialUserName">홍길동 <span>사원</span></div>
                                        <div class="specialUserTeam">연구개발본부 개발팀</div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div> -->
                        </div>
                    </div>

                    <div class="detailItem locate">
                        <div class="detailItemIcon">
                            <i class="bi bi-geo-alt"></i>
                        </div>
                        <div class="flexAlignCenter">
                            <div class="detailItemDes">
                                <input type="text" v-model="scheduleLocation" ref="scheduleLocation" placeholder="장소를 입력하세요.">
                            </div>
                        </div>
                    </div>
                    <!-- ▼ 줌 링크 추가 기능은 유료버전에만 해당되어 일단 항목만 넣어놓겠습니다 ▼ -->
                    <div class="detailItem zoomLink">
                        <div class="detailItemIcon">
                            <i class="bi bi-camera-video"></i>
                        </div>
                        <div class="flexAlignCenter">
                            <span class="underlineBtn" @click="showAlert()">화상회의 추가</span>
                        </div>
                    </div>

                    <div class="detailItem alretTime">
                        <div class="detailItemIcon">
                            <i class="bi bi-bell"></i>
                        </div>
                        <div class="flexAlignCenter">
                            <select id="options" v-model="beforeAlarm">
                                <option value="0">없음</option>
                                <option value="10">10분 전 미리 알림</option>
                                <option value="30">30분 전 미리 알림</option>
                                <option value="60">1시간 전 미리 알림</option>
                                <option value="120">2시간 전 미리 알림</option>
                                <option value="180">3시간 전 미리 알림</option>
                                <option value="1440">1일 전 미리 알림</option>
                                <option value="2880">2일 전 미리 알림</option>
                                <option value="10080">7일 전 미리 알림</option>
                            </select>
                        </div>
                    </div>

                </div>
                <div class="modalFeedDesInputBox">
                    <textarea name="" id="" class="modalFeedDesInput" v-model="scheduleContent" ref="scheduleContent" placeholder="내용을 작성하세요."></textarea>
                </div>
            </div>
            <div class="modalFooter">
                <div class="modalFooterBtnBox">
                    <div class="btnBox">
                        <i class="bi bi-fonts" @click="showAlert()"></i>
                        <i class="bi bi-paperclip" @click="showAlert()"></i>
                        <i class="bi bi-geo-alt" @click="showAlert()"></i>
                    </div>
                </div>
                <div class="modalFooterBtnBox">
                    <div class="dropdown">
                        <div class="dropdown-button" @click="toggleDropdown">{{ selectedOption }}</div>
                        <div class="dropdown-menu" v-show="isDropdownOpen">
                            <div class="dropdown-item" @click="selectItem('전체공개')">전체공개</div>
                            <div class="dropdown-item" @click="selectItem('프로젝트 관리자만')">프로젝트 관리자만</div>
                        </div>
                    </div>
                    <div class="preStorage" @click="showAlert()">
                        <span>임시저장</span>
                        <span class="gap"></span>
                        <span><b>0</b></span>
                    </div>
                    <button class="blueBtn" @click="addSchedule">등록</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiClient from "@/apiClient";
import { useToast } from "vue-toastification";
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },
  components: { DatePicker },
  props: ['projectId'],
  name: "ReportList",
  data() {
    return {
      subMenuGroups: [
        {
          title: "프로젝트 그룹 1",
          open: true,
          projects: ["프로젝트명 A", "프로젝트명 B", "프로젝트명 C"],
        },
        {
          title: "프로젝트 그룹 2",
          open: true,
          projects: ["프로젝트명 D", "프로젝트명 E"],
        },
      ],       
      showAddPostPopup: false,      // 글 작성 팝업
      showAddTaskPopup: false,      // 업무 작성 팝업
      showAddSchedulePopup: false,  // 일정 작성 팝업
      projectInfo: [],              // 해당 프로젝트 정보
      projectName: '',              // 해당 프로젝트명
      selectedViewType: 'P',        // 전체공개여부 설정(default는 'P(Public)' => 전체공개 / 'A(Admin)' => 프로젝트 관리자만)
      alertMsg: {
        commingSoon:  '준비중입니다.',
        postSubject: '글 제목을 입력해주세요.',
        postContent: '글 내용을 입력해주세요.', 
        successPostAdd: '글 성공적으로 등록되었습니다.',
        failPostAdd: '글 등록 중 오류가 발생했습니다.',
        successTaskAdd: '업무가 성공적으로 등록되었습니다.',
        failTaskAdd: '업무 등록 중 오류가 발생했습니다.',
        successScheduleAdd: '일정이 성공적으로 등록되었습니다.',
        failScheduleAdd: '일정 등록 중 오류가 발생했습니다.',
        taskStartDateValid: '시작일은 마감일보다 이후일 수 없습니다.',
        taskEndDateValid: '마감일은 시작일보다 이전일 수 없습니다.',
        taskSubject: '업무 제목을 입력해주세요.',
        taskStatus: '업무 상태를 선택해주세요.',
        taskManager: '담당자를 추가해주세요.',
        taskStartDate: '시작일을 선택해주세요.',
        taskEndDate: '마감일을 선택해주세요.',
        taskContent: '업무 내용을 입력해주세요.',
        scheduleSubject:  '일정 제목을 입력해주세요.',
        scheduleStartDate: '일정 시작일을 선택해주세요.',
        scheduleEndDate: '일정 마감일을 선택해주세요.',
        scheduleContent:  '일정 내용을 입력해주세요.',
        scheduleParticipant: '참석자를 선택해주세요.',
        scheduleStartDateValidNow: '시작일은 현재시간보다 이후이어야 합니다.',
        scheduleStartDateValid: '시작일은 마감일보다 이후일 수 없습니다.',
        scheduleEndDateValidNow: '마감일은 현재시간보다 이후이어야 합니다.',
        scheduleEndDateValid: '마감일은 시작일보다 이전일 수 없습니다.',
        checkAllday: '시작일과 마감일을 먼저 선택해주세요.',
        commentContent: '댓글내용을 입력해주세요.',
        successCommentAdd: '댓글이 성공적으로 등록되었습니다.',
        failCommentAdd: '댓글 등록 중 오류가 발생했습니다.',
        successLikeFeed: '해당 피드에 대해 좋아요 했습니다.',
        successUnLikeFeed: '해당 피드에 대해 좋아요 취소했습니다.',
        failLikeFeed: '해당 피드에 대해 좋아요 실패하였습니다.',
        successBookmarkFeed: '해당 피드에 대해 북마크 했습니다.',
        successUnBookmarkFeed: '해당 피드에 대해 북마크 취소했습니다.',
        failBookmarkFeed: '해당 피드에 대해 북마크 실패하였습니다.',
        successAttendStatus: '일정의 참석여부가 수정되었습니다.',
        failAttendStatus: '일정의 참석여부 수정 중 오류가 발생했습니다.',
        successLikeFeedComment: '해당 댓글에 대해 좋아요 했습니다.',
        successUnLikeFeedComment: '해당 댓글에 대해 좋아요 취소했습니다.',
        failLikeFeedComment: '해당 댓글에 대해 좋아요 실패하였습니다.',
      },
      priorities: [
            { id: 4, text: '낮음', class: 'priority4', icon: 'bi-caret-down-fill', value: 'L'},
            { id: 3, text: '보통', class: 'priority3', icon: 'bi-caret-right-fill', value: 'M' },
            { id: 2, text: '높음', class: 'priority2', icon: 'bi-caret-up-fill', value: 'H' },
            { id: 1, text: '긴급', class: 'priority1', icon: 'bi-fire', value: 'U' }
      ],
      subTaskPriorities: [
            { id: 4, text: '낮음', class: 'priority4', icon: 'bi-caret-down-fill', color: 'var(--txt6)', value: 'L' },
            { id: 3, text: '보통', class: 'priority3', icon: 'bi-caret-right-fill', color: 'var(--mizeBlue)', value: 'M' },
            { id: 2, text: '높음', class: 'priority2', icon: 'bi-caret-up-fill', color: 'var(--pointYellow)', value: 'H' },
            { id: 1, text: '긴급', class: 'priority1', icon: 'bi-fire', color: 'var(--pointRed)', value: 'U' }
      ],
      statusMap: {
        'R': '요청',
        'P': '진행',
        'F': '피드백',
        'C': '완료',
        'H': '보류'
      },
      taskProgress: 0,
      isDropdownOpen: false,
      selectedOption: "전체공개",      
      selectedTaskStatus: '',           // 업무작성 팝업 > 업무상태 => 요청 : R(Request) / 진행 : P(Progress) / 피드백 : F(Feedback) / 완료 : C(Completed) / 보류 : H(Hold)
      isTaskStartDatePickerOpen: false, // 업무작성 팝업 > 시작일 선택 팝업 오픈 여부
      isTaskEndDatePickerOpen: false,   // 업무작성 팝업 > 종료일 선택 팝업 오픈 여부
      isManagerPopupOpen: false,        // 담당자 추가
      isPriorityPopupOpen: false,       // 우선순위 추가
      isPriorityProgressOpen: false,    // 항목추가입력 클릭 시, 우선순위 & 진행률(%) 영역
      searchManagerName: "",            // 담당자 추가 시, 검색할 이름 입력값
      searchManagerUserList: [],        // 담당자 추가 시, 검색된 사용자 리스트
      selectedTaskManager: "",          // 업무작성 팝업 > 선택된 담당자 정보
      selectedTaskStartDate: null,      // 업무작성 팝업 > 선택된 시작일
      selectedTaskEndDate: null,        // 업무작성 팝업 > 선택된 마감일
      selectedPriority: null,           // 업무작성 팝업 > 선택된 우선순위
      subTaskList: [],                  // 업무작성 팝업 > 하위 업무 목록 배열

      isScheduleStartDatePickerOpen: false, // 일정작성 팝업 > 시작일 선택 팝업 오픈 여부
      isScheduleEndDatePickerOpen: false,   // 일정작성 팝업 > 종료일 선택 팝업 오픈 여부
      isParticipantPopupOpen: false,        // 참석자 추가
      searchParticipantName: "",            // 참석자 추가 시, 검색할 이름 입력값
      searchParticipantUserList: [],        // 참석자 추가 시, 검색된 사용자 리스트
      selectedParticipantUserList: [],      // 일정작성 팝업 > 선택된 참석자들 정보
      selectedScheduleStartDate: null,      // 일정작성 팝업 > 선택된 시작일
      selectedScheduleEndDate: null,        // 일정작성 팝업 > 선택된 마감일
      isAllDay: 'N',                        // 종일여부
      beforeAlarm: 0,                       // 미리알림(분단위)
      
      feedList: [],                         // 피드 리스트 데이터
      currentPage: 1,
      pageSize: 30,
      hasMore: true,
      totalFeedCount: 0,

      newComment: "",                       // 입력한 댓글
      comments: [],                         // 등록된 댓글 리스트
      currentUserPhoto: "https://mizecloud-partners.co.kr/employee_img/" + localStorage.getItem("userphoto"),   // 현재 사용자 프로필 이미지
      defaultProfileImg: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s", // 사용자 이미지 없는 경우 대체 이미지
      visibleComments: {},
      initCommentViewCount: 5,              // 처음에 보여줄 댓글 카운트 
      moreCommentViewCount: 5,              // 이전댓글 더보기 클릭 시, 보여줄 댓글 카운트
    };
  },
  computed: {
        formattedTaskStartDate() {
            if (!this.selectedTaskStartDate) return '';
            const date = new Date(this.selectedTaskStartDate);
            const options = { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' };
            return date.toLocaleDateString('ko-KR', options).replace(/\s/g, '');
        },
        formattedTaskEndDate() {
            if (!this.selectedTaskEndDate) return '';
            const date = new Date(this.selectedTaskEndDate);
            const options = { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' };
            return date.toLocaleDateString('ko-KR', options).replace(/\s/g, '');
        },
        canCheckAllDay() {            
            return !!this.selectedScheduleStartDate && !!this.selectedScheduleEndDate; 
        },
    },
  watch: {
    searchManagerName(newVal) {
        if (newVal.trim() === "") {
            this.searchManagerUserList = [];
            return;
        }
        this.searchManager(newVal);     
    },
    searchParticipantName(newVal) {
        if (newVal.trim() === "") {
            this.searchParticipantUserList = [];
            return;
        }
        this.searchParticipant(newVal);     
    },
    isAllDay(val) {
        if (!this.scheduleStartDateTime || !this.scheduleEndDateTime) return;

        if (val === 'Y') {
            const startDate = this.scheduleStartDateTime.slice(0, 10);
            const endDate = this.scheduleEndDateTime.slice(0, 10);
            this.selectedScheduleStartDate = this.scheduleStartDateTime = startDate + 'T00:00';
            this.selectedScheduleEndDate = this.scheduleEndDateTime = endDate + 'T23:59';
        }
    }
  },
  methods: {
    toggleGroup(index) {
      this.subMenuGroups[index].open = !this.subMenuGroups[index].open;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    formatDateToYYYYMMDD(date) {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatDate(value) {
        if (!value) return '';
        const date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day} ${hour}:${minute}`;
    },
    formatDate2(value) {
        if (!value) return '';

        const parts = value.split(' ');
        if (parts.length < 3) return value;

        const datePart = parts[0];
        const ampm = parts[1];
        const timePart = parts[2];

        let [hour, minute] = timePart.split(':');
        hour = parseInt(hour, 10);

        if (ampm === '오후' && hour < 12) {
            hour += 12;
        }
        if (ampm === '오전' && hour === 12) {
            hour = 0;
        }

        return `${datePart} ${String(hour).padStart(2, '0')}:${minute}`;
    },    
    formatDate3(value, mode = 'datetime') {
        if (!value) return '';

        const parts = value.split(' ');
        const datePart = parts[0];
        const timePart = parts[2];

        const [year, month, day] = datePart.split('-');
        const [hour, minute] = timePart.split(':');

        switch (mode) {
            case 'yearMonth':
                return `${year}-${month}`;
            case 'day':
                return day;
            case 'time':
                return `${hour}:${minute}`;
            default:
                return `${year}-${month}-${day} ${hour}:${minute}`;
        }
    },
    formatSchedule(feed) {
        if (feed.alldayYN === 'Y') return '종일';

        const parseParts = (dt) => {
            const parts = dt.split(' ');
            return {
                date: parts[0],
                ampm: parts[1],
                time: parts[2]
            };
        };

        const start = parseParts(feed.startDtm);
        const end   = parseParts(feed.endDtm);

        const getWeekday = (dateStr) => {
            const [y, m, d] = dateStr.split('-').map(Number);
            const week = ['일','월','화','수','목','금','토'];
            return week[new Date(y, m - 1, d).getDay()];
        };

        const formatTime = (timeStr) => {
            const [hour, minute] = timeStr.split(':');
            return `${hour}:${minute}`;
        };

        const startDateStr = `${start.date} (${getWeekday(start.date)})`;
        const endDateStr   = `${end.date} (${getWeekday(end.date)})`;

        const startTimeStr = `${start.ampm} ${formatTime(start.time)}`;
        const endTimeStr   = `${end.ampm} ${formatTime(end.time)}`;

        if (start.date === end.date) {
            return `${startDateStr} ${startTimeStr} ~ ${endTimeStr}`;
        } else {
            return `${startDateStr} ${startTimeStr} ~ ${endDateStr} ${endTimeStr}`;
        }
    },
    getWeekofDay(dateStr) {
        const date = new Date(dateStr);
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        return days[date.getDay()];
    },
    selectItem(option) {
      this.selectedOption = option;
      this.isDropdownOpen = false;
      if (option === "전체공개") {
        this.selectedViewType = "P";
      } else if (option === "프로젝트 관리자만") {
        this.selectedViewType = "A";
      } 
    },
    handleTaskStartDateChange(date) {
        if (this.selectedTaskEndDate && date > this.selectedTaskEndDate) {
            this.toast.error(this.alertMsg['taskStartDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
            this.selectedTaskStartDate = null;
        } else {
            this.selectedTaskStartDate = date;
        }
        this.isTaskStartDatePickerOpen = false;
    },
    handleTaskEndDateChange(date) {
        if (this.selectedTaskStartDate && date < this.selectedTaskStartDate) {
            this.toast.error(this.alertMsg['taskEndDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
            this.selectedTaskEndDate = null;
        } else {
            this.selectedTaskEndDate = date;
        }
        this.isTaskEndDatePickerOpen = false;
    },    
    handleScheduleStartDateChange() {
        if (!this.scheduleStartDateTime) return;

        const start = new Date(this.scheduleStartDateTime);
        const end = this.scheduleEndDateTime ? new Date(this.scheduleEndDateTime) : null;
        const now = new Date();
        
        if (start < now) {
            this.toast.error(this.alertMsg['scheduleStartDateValidNow'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleStartDateTime.value = '';
            this.scheduleStartDateTime = '';
            return;
        }

        if (end && start > end) {
            this.toast.error(this.alertMsg['scheduleStartDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleStartDateTime.value = '';
            this.scheduleStartDateTime = '';
            return;
        }

        this.selectedScheduleStartDate = this.$refs.scheduleStartDateTime.value;
    },
    handleScheduleEndDateChange() {
        if (!this.scheduleEndDateTime) return;

        const end = new Date(this.scheduleEndDateTime);
        const now = new Date();

        if (end < now) {
            this.toast.error(this.alertMsg['scheduleEndDateValidNow'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleEndDateTime.value = '';
            this.scheduleEndDateTime = '';            
            return;
        }

        if (!this.scheduleStartDateTime) return;

        const start = new Date(this.scheduleStartDateTime);

        if (end < start) {
            this.toast.error(this.alertMsg['scheduleEndDateValid'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });

            this.$refs.scheduleEndDateTime.value = '';
            this.scheduleEndDateTime = '';
            return;
        }

        this.selectedScheduleEndDate = this.$refs.scheduleEndDateTime.value;
    },
    navigateProjectMenu(menu) {
        const nameMap = {
            //feed: 'ReportFeed',
            feed: 'ReportList',
            task: 'ReportTask',
            calendar: 'ReportCalendar'
        };

        if (nameMap[menu]) {
            this.$router.push({ name: nameMap[menu], params: { projectId: this.projectId } });
        } else {
            console.warn(`Unknown menu: ${menu}`);
        }
    },
    async getProjectInfo() {
      try {
        const response = await apiClient.post("/api/Project/project-info", {
          ProjectId: this.projectId,
        });

        if (response.status === 200) {
          const data = response.data;
          this.projectInfo = data.project || {};
          this.projectName = data.project.Name;
        }
      } catch (error) {
        console.error("Error fetching projectInfo data:", error);
      }
    },
    async getFeedList() {
        if (!this.hasMore) return;
        
        try {
            const response = await apiClient.post("/api/Feed/feed-list", {
                Page: this.currentPage, 
                PageSize: this.pageSize,
                ProjectId: this.projectId,                
                LoginUserId: localStorage.getItem("userid"),
            });

            if (response.status === 200) {
                const result = JSON.parse(response.data);
                const newData = Array.isArray(result.data) ? result.data : [];

                newData.forEach(feed => {
                    if (feed.comments && Array.isArray(feed.comments)) {
                        feed.comments = this.normalizeComments(feed.comments);
                        feed.comments = this.setCommentTree(feed.comments);
                        this.initVisibleComments(feed);
                    }
                    else
                        feed.comments = [];
                });

                this.feedList = [...this.feedList, ...newData];
                this.feedList = [...this.feedList, ...newData].reduce((acc, curr) => {
                    if (!acc.find(f => f.feedId === curr.feedId && f.feedType === curr.feedType)) {
                        acc.push(curr);
                    }
                    return acc;
                }, []);
                
                this.totalCount = result.meta.count;

                if (this.feedList.length >= this.totalCount || newData.length < this.pageSize)
                    this.hasMore = false;
                else
                    this.currentPage += 1;
            }
        } catch (error) {
            console.error("Error fetching feedList data:", error);
        }
    },
    async addPost() {
      if (!this.postSubject || this.postSubject.trim() === "") {
        this.toast.error(this.alertMsg['postSubject'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        this.$refs.postSubject.focus();
        return; 
      }
      if (!this.postContent || this.postContent.trim() === "") {
        this.toast.error(this.alertMsg['postContent'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        this.$refs.postContent.focus();
        return; 
      }

      try {
          const response = await apiClient.post(`/api/Post/post-add`, {
            LoginUserId: localStorage.getItem("userid"),
            ProjectId: this.projectId,
            Subject: this.postSubject,
            Content: this.postContent,
            ViewType: this.selectedViewType
          });

          if (response.status === 200) {
            this.toast.success(this.alertMsg['successPostAdd'], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            this.showAddPostPopup = false;
            this.initPostPopupVaule();
          }
      } catch (error) {
        console.error("Error adding post data:", error);
        this.toast.error(this.alertMsg['failPostAdd'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
      }
    },
    async addComment(feedId, feedType, parentCommentId = 0) {
        if (!this.newComment || this.newComment.trim() === "") {
            this.toast.error(this.alertMsg['commentContent'], { 
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
            this.$refs.newComment.focus();
            return; 
        }

        try {
            const response = await apiClient.post(`/api/Feed/feed-comment-add`, {
                FeedId: feedId,
                ParentCommentId: parentCommentId,
                FeedType: feedType,
                CommentContent: this.newComment,
                CreatedUserId: localStorage.getItem("userid"),
            });

            if (response.status === 200) {
                const savedComment = response.data.comment;      
                const feed = this.feedList.find(f => f.feedId === savedComment.FeedId);

                if (feed) {
                    if (!feed.comments) feed.comments = [];

                    const newComment = {
                        id: savedComment.CommentId,
                        feedId: savedComment.FeedId,
                        parentCommentId: Number(savedComment.ParentCommentId),
                        commentContent: savedComment.CommentContent,
                        createdDtm: savedComment.CreatedDtm,
                        createdUserId: savedComment.CreatedUserId,
                        createdUserName: savedComment.CreatedUserName,
                        createdUserPhoto: savedComment.CreatedUserPhoto,
                        children: []
                    };

                    if (newComment.parentCommentId && newComment.parentCommentId !== 0) {
                        const parent = feed.comments.find(c => c.id === newComment.parentCommentId);
                    if (parent) {
                        if (!parent.children) parent.children = [];
                        parent.children.push(newComment);
                    } else {
                        feed.comments.push(newComment);
                    }
                    } else {
                        feed.comments.unshift(newComment);
                    }

                    feed.comments.sort((a, b) => new Date(b.createdDtm) - new Date(a.createdDtm)); 
                    if (!this.visibleComments[feed.feedId]) {
                        this.visibleComments[feed.feedId] = 0;
                    }
                    this.visibleComments[feed.feedId] = this.visibleComments[feed.feedId] + 1;

                    if (typeof feed.commentCount === "number") {
                        feed.commentCount += 1;
                    }

                    this.newComment = "";
                }
            }
        } catch (error) {
            console.error("Error adding comment data:", error);
            this.toast.error(this.alertMsg['failCommentAdd'], { 
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
        }
    },
    setCommentTree(flatComments) {
        const map = {};
        const roots = [];

        flatComments.forEach(c => {
            map[c.id] = { ...c, children: [] };
        });

        flatComments.forEach(c => {
            if (c.parentCommentId && c.parentCommentId !== 0) {
            if (map[c.parentCommentId]) {
                map[c.parentCommentId].children.push(map[c.id]);
            }
            } else {
            roots.push(map[c.id]);
            }
        });

        return roots;
    },
    normalizeComments(comments) {
        return comments.map(c => ({
            id: c.commentId,
            feedId: c.feedId,
            feedType: c.feedType,
            parentCommentId: c.parentCommentId,
            commentContent: c.commentContent,
            createdDtm: c.createdDtm,
            createdUserId: c.createdUserId,
            createdUserName: c.createdUserName,
            createdUserPhoto: c.createdUserPhoto,
            commentLikeActiveYn: c.commentLikeActiveYn,
            children: []
        }));
    },
    async addTask() {
      if (!this.taskSubject || this.taskSubject.trim() === "") {
        this.toast.error(this.alertMsg['taskSubject'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.taskSubject.focus();
        return; 
      }
      if (!this.selectedTaskStatus) {
        this.toast.error(this.alertMsg['taskStatus'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedTaskManager) {
        this.toast.error(this.alertMsg['taskManager'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedTaskStartDate) {
        this.toast.error(this.alertMsg['taskStartDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedTaskEndDate) {
        this.toast.error(this.alertMsg['taskEndDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.taskContent || this.taskContent.trim() === "") {
        this.toast.error(this.alertMsg['taskContent'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.taskContent.focus();        
        return; 
      }

      try {
          const subTaskListData = Array.isArray(this.subTaskList)
            ? this.subTaskList
            .filter(subtask => subtask.name && subtask.name.trim() !== '')
            .map(subtask => ({
                SubTaskSubject: subtask.name,
                SubTaskStatus: subtask.status,
                SubTaskEndDate: this.formatDateToYYYYMMDD(subtask.subTaskEndDate),
                SubTaskPriority: subtask.selectedSubTaskPriority?.value || null,
                SubTaskManagerUserId: subtask.selectedSubTaskManager?.managerUserId || null
                }))
            : [];
            
          const response = await apiClient.post(`/api/Task/task-add`, {
            LoginUserId: localStorage.getItem("userid"),
            ProjectId: this.projectId,
            Subject: this.taskSubject,
            ManagerUserId: this.selectedTaskManager.managerUserId,
            Status: this.selectedTaskStatus,
            TaskStartDate : this.formatDateToYYYYMMDD(this.selectedTaskStartDate),
            TaskEndDate : this.formatDateToYYYYMMDD(this.selectedTaskEndDate),
            Priority: this.selectedPriority?.value || null,       
            ProgressNum: this.taskProgress,            
            Content: this.taskContent,
            ViewType: this.selectedViewType,
            SubTaskList: subTaskListData
          });

          if (response.status === 200) {
            this.toast.success(this.alertMsg['successTaskAdd'], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            this.showAddTaskPopup = false;
            this.initTaskPopupVaule();
          }
      } catch (error) {
        console.error("Error adding task data:", error);
        this.toast.error(this.alertMsg['failTaskAdd'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
      }
    },
    async addSchedule() {
      if (!this.scheduleSubject || this.scheduleSubject.trim() === "") {
        this.toast.error(this.alertMsg['scheduleSubject'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.scheduleSubject.focus();
        return; 
      }
      if (!this.selectedScheduleStartDate) {
        this.toast.error(this.alertMsg['scheduleStartDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedScheduleEndDate) {
        this.toast.error(this.alertMsg['scheduleEndDate'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }
      if (!this.selectedParticipantUserList.length) {
        this.toast.error(this.alertMsg['scheduleParticipant'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        
        return; 
      }  
      if (!this.scheduleContent || this.scheduleContent.trim() === "") {
        this.toast.error(this.alertMsg['scheduleContent'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });

        this.$refs.scheduleContent.focus();        
        return; 
      }

      try {
          const participantListData = Array.isArray(this.selectedParticipantUserList)
            ? this.selectedParticipantUserList.map(participantUser => ({
                    ScheduleParticipantUserId: participantUser.managerUserId
                }))
            : [];
            
          const response = await apiClient.post(`/api/Schedule/schedule-add`, {
            LoginUserId: localStorage.getItem("userid"),
            ProjectId: this.projectId,
            Subject: this.scheduleSubject,
            StartDtm : this.selectedScheduleStartDate,
            EndDtm : this.selectedScheduleEndDate,
            AlldayYn: this.isAllDay,
            Location: this.scheduleLocation ? this.scheduleLocation : '',
            BeforeAlarm: this.beforeAlarm,
            Content: this.scheduleContent,
            ParticipantList: participantListData
          });

          if (response.status === 200) {
            this.toast.success(this.alertMsg['successScheduleAdd'], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            this.showAddSchedulePopup = false;
            this.initSchedulePopupVaule();
          }
      } catch (error) {
        console.error("Error adding task data:", error);
        this.toast.error(this.alertMsg['failScheduleAdd'], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
      }
    },
    async searchManager(keyword) {
      try {
        const response = await apiClient.post("/api/Task/manager-search", {
          ManagerUserName: keyword 
        });
        
        if (response.status === 200) {
            const data = JSON.parse(response.data);
            this.searchManagerUserList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching managerUserList data:", error);
      }
    },
    async searchParticipant(keyword) {
      try {
        const response = await apiClient.post("/api/Task/manager-search", {
          ManagerUserName: keyword 
        });
        
        if (response.status === 200) {
            const data = JSON.parse(response.data);
            this.searchParticipantUserList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching participantUserList data:", error);
      }
    },
    selectTaskManager(person) {
        this.selectedTaskManager = person;
        this.isManagerPopupOpen = false;
        this.searchManagerName = '';
    },
    selectPriority(priority) {
        this.selectedPriority = priority;
        this.isPriorityPopupOpen = false;
    },    
    selectScheduleParticipant(person) {
        const isExist = this.selectedParticipantUserList.some(
            user => user.managerUserId === person.managerUserId
        );

        if (!isExist) {
            this.selectedParticipantUserList.push(person);
        }
        
        this.isParticipantPopupOpen = false;
        this.searchParticipantName = '';
    },
    removeParticipant(index) {
        this.selectedParticipantUserList.splice(index, 1);
    },
    handleManagerInput(event) {
        this.searchManagerName = event.target.value;
    },
    handleParticipantInput(event) {
        this.searchParticipantName = event.target.value;
    },
    checkAllDayClick(e) {
        if (!this.canCheckAllDay) {
            e.preventDefault();
            this.toast.error(this.alertMsg['checkAllday'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
        }
    },
    initPostPopupVaule() {
      this.postSubject = this.postContent = '';
      this.selectedViewType = 'P';
    },
    initTaskPopupVaule() {
      this.taskSubject = '';
      this.selectedTaskStatus = '';
      this.selectedTaskManager = '';
      this.selectedTaskStartDate = '';
      this.selectedTaskEndDate = '';
      this.selectedPriority = '';
      this.isPriorityProgressOpen = false;
      this.taskProgress = 0;
      this.taskContent = '';
      this.subTaskList = [];
    },
    initSchedulePopupVaule() {
      this.scheduleSubject = '';
      this.selectedParticipantUserList = [];
      this.scheduleStartDateTime = '';
      this.scheduleEndDateTime = '';
      this.selectedScheduleStartDate = '';
      this.selectedScheduleEndDate = '';
      this.scheduleLocation = '';
      this.scheduleContent = '';
      this.isAllDay = 'N';
      this.beforeAlarm = 0;
    },
    initAllPopup(type) {
      ['showAddPostPopup', 'showAddTaskPopup', 'showAddSchedulePopup'].forEach(key => {
        this[key] = false;
      });

      const map = {
        post: 'showAddPostPopup',
        task: 'showAddTaskPopup',
        schedule: 'showAddSchedulePopup',
      };

      if (map[type]) {
        this[map[type]] = true;
      }

      this.initPostPopupVaule();
      this.initTaskPopupVaule();
      this.initSchedulePopupVaule();
    },
    updateTaskProgress(event) {
        this.taskProgress = Number(event.target.value);
    },
    addSubTask() {
        const newSubTask = {
            id: Date.now(),
            status: 'R',
            name: '',
            isDatePickerOpen: false,
            subTaskEndDate: null,
            isSubTaskPriorityPopupOpen: false,
            selectedSubTaskPriority: null,
            isSubTaskManagerPopupOpen: false,
            selectedSubTaskManager: null,
        };
        
        this.subTaskList.push(newSubTask);

        this.$nextTick(() => {
            let el = this.$refs['subtask_' + newSubTask.id];

            if (Array.isArray(el)) el = el[0];
            if (el) el.focus();
        });
    },    
    handleEnter() {
        this.addSubTask();

        this.$nextTick(() => {
            const last = this.subTaskList[this.subTaskList.length - 1];
            const refName = 'subtask_' + last.id;

            let input = this.$refs[refName];

            if (Array.isArray(input)) input = input[0];

            if (input) {
                if (typeof input.focus === 'function') {
                    input.focus();
                } else if (input.$el && typeof input.$el.focus === 'function') {
                    input.$el.focus();
                }
            }
        });
    },
    toggleDatePicker(clickedSubTask) {        
        if (clickedSubTask.isDatePickerOpen) {
            clickedSubTask.isDatePickerOpen = false;
            return;
        }

        this.subTaskList.forEach(subTask => {
            subTask.isDatePickerOpen = false;
            subTask.isSubTaskPriorityPopupOpen = false;
            subTask.isSubTaskManagerPopupOpen = false;
        });

        this.$nextTick(() => {
            clickedSubTask.isDatePickerOpen = true;
        });
    },
    togglePriorityPopup(clickedSubTask) {    
        this.subTaskList.forEach(subTask => {
            subTask.isDatePickerOpen = false;
            subTask.isSubTaskManagerPopupOpen = false;

            if (subTask !== clickedSubTask) {
                subTask.isSubTaskPriorityPopupOpen = false;
            }
        });

        clickedSubTask.isSubTaskPriorityPopupOpen = !clickedSubTask.isSubTaskPriorityPopupOpen;
    },
    toggleManagerPopup(clickedSubTask) {
        this.searchManagerName = '';
        this.subTaskList.forEach(subTask => {
            subTask.isDatePickerOpen = false;
            subTask.isSubTaskPriorityPopupOpen = false;

            if (subTask !== clickedSubTask) {
                subTask.isSubTaskManagerPopupOpen = false;
            }
        });

        clickedSubTask.isSubTaskManagerPopupOpen = !clickedSubTask.isSubTaskManagerPopupOpen;
    },
    selectSubTaskPriority(subTask, priority) {
        subTask.selectedSubTaskPriority = priority;
        subTask.isSubTaskPriorityPopupOpen = false;
    },
    selectSubTaskManager(subTask, person) {
        subTask.selectedSubTaskManager = person;
        subTask.isSubTaskManagerPopupOpen = false;
    },
    showAlert() {
        this.toast.error(this.alertMsg['commingSoon'], {
            position: "top-center", // 메시지 위치
            timeout: 1500, // 3초 동안 표시
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: true, // 진행 표시줄 숨기기
            closeButton: false, // X 버튼 숨기기
        });
    },
    initVisibleComments(feed) {
        if (feed.comments && feed.comments.length > 0) {
            this.visibleComments[feed.feedId] = Math.min(this.initCommentViewCount, feed.comments.length);
        }
    },
    showMoreComments(feed) {
        const current = this.visibleComments[feed.feedId] || 0;
        const total = feed.comments.length;
        const next = Math.min(current + this.moreCommentViewCount, total);
        this.visibleComments[feed.feedId] = next
    },
    async likeFeed(feed) {
        try {            
          const likeActiveYN = feed.likeActiveYN === 'Y' ? 'N' : 'Y';

          const response = await apiClient.post(`/api/Feed/feed-like`, {
            FeedId: feed.feedId,
            FeedType: feed.feedType,
            LikeActiveYN: likeActiveYN,
            CreatedUserId: localStorage.getItem("userid"),
          });

          if (response.status === 200) {
            feed.likeActiveYN = likeActiveYN;

            if (likeActiveYN === 'Y') {
                this.toast.success(this.alertMsg['successLikeFeed'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            } else {
                this.toast.success(this.alertMsg['successUnLikeFeed'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            }
          }
      } catch (error) {
            console.error("Error like feed data:", error);
            this.toast.error(this.alertMsg['failLikeFeed'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
      }
    },
    async likeBookmark(feed) {
        try {
          const bookmarkActiveYN = feed.bookmarkActiveYN === 'Y' ? 'N' : 'Y';

          const response = await apiClient.post(`/api/Feed/feed-bookmark`, {
            FeedId: feed.feedId,
            FeedType: feed.feedType,
            BookmarkActiveYN: bookmarkActiveYN,
            CreatedUserId: localStorage.getItem("userid"),
          });

          if (response.status === 200) {
            feed.bookmarkActiveYN = bookmarkActiveYN;
            
            if (bookmarkActiveYN === 'Y') {
                this.toast.success(this.alertMsg['successBookmarkFeed'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            } else {
                this.toast.success(this.alertMsg['successUnBookmarkFeed'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            }
          }
      } catch (error) {
            console.error("Error bookmark feed data:", error);
            this.toast.error(this.alertMsg['failBookmarkFeed'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
      }
    },
    async likeFeedComment(comment) {
        try {            
          const likeActiveYN = comment.commentLikeActiveYn === 'Y' ? 'N' : 'Y';
          
          const response = await apiClient.post(`/api/Feed/feed-comment-like`, {
            FeedId: comment.feedId,
            CommentId: comment.id,
            FeedType: comment.feedType,
            LikeActiveYN: likeActiveYN,
            CreatedUserId: localStorage.getItem("userid"),
          });

          if (response.status === 200) {
            comment.commentLikeActiveYn = likeActiveYN;

            if (likeActiveYN === 'Y') {
                this.toast.success(this.alertMsg['successLikeFeedComment'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            } else {
                this.toast.success(this.alertMsg['successUnLikeFeedComment'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });
            }
          }
      } catch (error) {
            console.error("Error like feed data:", error);
            this.toast.error(this.alertMsg['failLikeFeedComment'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
      }
    },
    async updateAttendStatus(feed, status) {
        try {
            const response = await apiClient.post(`/api/Feed/feed-schedule-attend-status-update`, {
                FeedId: feed.feedId,
                AttendStatus: status,
                CreatedUserId: localStorage.getItem("userid"),
            });
            
            if (response.status === 200) {
                feed.attendStatus = status;
                const loginUserId = localStorage.getItem("userid");
                const participant = feed.participantList.find(p => p.participantUserId === loginUserId);
                if (participant) {
                    participant.attendStatus = status;
                }

                this.toast.success(this.alertMsg['successAttendStatus'], {
                    position: "top-center", // 메시지 위치
                    timeout: 1500, // 3초 동안 표시
                    closeOnClick: true,
                    pauseOnHover: true,
                    hideProgressBar: true, // 진행 표시줄 숨기기
                    closeButton: false, // X 버튼 숨기기
                });

            }
        } catch (error) {
            console.error("Error editing attend status data:", error);
            this.toast.error(this.alertMsg['failAttendStatus'], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
            });
        }
    },
    getMyAttendStatus(feed) {
        const loginUserId = localStorage.getItem("userid");
        const participant = feed.participantList.find(p => p.participantUserId === loginUserId);
        return participant ? participant.attendStatus : null;
    },
    getStatusClass(status) {
        switch(status) {
            case 'R': return 'request';
            case 'P': return 'inProgress';
            case 'F': return 'feedback';
            case 'C': return 'completed';
            case 'onHold': return 'onHold';
            default: return '';
        }
    },
    getStatusLabel(status) {
        switch(status) {
            case 'R': return '요청';
            case 'P': return '진행';
            case 'F': return '피드백';
            case 'C': return '완료';
            case 'H': return '보류';
            default: return '';
        }
    }
  },
  mounted() {
    this.getProjectInfo();
    this.getFeedList();
  }
};
</script>
<style scoped>
.progressBox {
    display: flex;
    align-items: center;
    gap: 10px;
}
input[type="range"] {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 10px; 
    background: #d3d3d3; 
    outline: none;
    border-radius: 5px;    
    flex-grow: 1;
}
input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background: #007bff;
    cursor: pointer;
    border-radius: 50%;
    margin-top: -5px;
}
input[type="range"]::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: #007bff;
    cursor: pointer;
    border-radius: 50%;
}
</style>